namespace SPA
{
	export namespace Realtor {

		import BaseHTMLElement = ui.base.BaseHTMLElement;

		export class AttachmentBuilder
			extends ObjectDataBuilder<RealtorObjectModel>
		{
			private	m_Parent:	JQuery|ui.base.BaseHTMLElement|null;
			private docManager: DocumentManager;
			private groupContainer: Array<{group: IDocumentGroup, el: JQuery}>;
			private docContainer: Array<{file: IDocument, el: JQuery}>;
			private watchInterval: number;

			private btnRefreshData: JQuery;

			public constructor( data: RealtorObjectModel, docManager: DocumentManager)
			{
				super( data );

				this.m_Parent	= null;
				this.docManager = docManager;
				// Todo Workaround for now! Bind DocManager to specific object
				this.m_Data.docManager = docManager;
				this.groupContainer = [];
				this.docContainer = [];
				this.watchInterval = 0;

				// Initialize the Refresh Button
				this.btnRefreshData = $('<button class="btn btn-sm btn-default btn-refresh"><i class="fas fa-sync-alt"></i> <span class="hidden-xs">Dokumente neu laden</span></button>');
			}

			public rebuild( root: ui.base.BaseHTMLElement|JQuery<HTMLElement>, navigation?: Navigation, isExposeFilter: boolean = false): AttachmentBuilder
			{
				const basicBox = new ui.Box.Box();

				basicBox.clearTitle();
				basicBox.rebuild( root.empty() );

				this.m_Parent	= root;

				basicBox.append($('<div class="refresh-outer text-right"></div>').append(this.btnRefreshData));

				this.btnRefreshData.on("click", () => {
					this.refreshView();
				});

				for (const group of this.docManager.getGroups())
				{
					if (isExposeFilter) {
						if (group.id === 4 || group.id === 5) {
							// Add Group Title
							basicBox.append(ui.$$.h(2, [$('<span>' + group.title + '</span>')]).addClass('segment'));

							// Build each groups document list
							const documentContainer = ui.$$.div().addClass('doc-card-container');
							this.groupContainer.push({group, el: documentContainer});

							basicBox.append(documentContainer);
							this.buildDocumentGroup(group, documentContainer);
						}
					} else if (group.id !== 4 && group.id !== 5) {
						// const bGroup = new DocumentGroup(group);

						// Add Group Title
						basicBox.append(ui.$$.h(2, [$('<span>' + group.title + '</span>')]).addClass('segment'));

						// Build each groups document list
						const documentContainer = ui.$$.div().addClass('doc-card-container');
						this.groupContainer.push({group, el: documentContainer});

						basicBox.append(documentContainer);
						this.buildDocumentGroup(group, documentContainer);
					}
				}

				const list = new ui.base.BaseHTMLElement( 'card-list' ).appendTo( basicBox ).addClass( 'flex-4' );

				(this.m_Data.Attachments as Wollmilch.Realtor.Attachment[]).forEach(
				(element) =>
				{
					const row = ui.$$.div().addClass( 'row' );

					const AttachmentBox = new ui.base.BaseHTMLElement( 'card' ).addClass( 'box' )
						// .append(
						// 	ui.$$.p().addClass( 'box-title small-caps' ).text( element.Name )
						// )
						.appendTo( list );

					const buttonplane = ui.$$.div()
						.addClass('buttonplane')
						.appendTo( AttachmentBox.Root() );

					if ( element.Artifact && element.Artifact.DataLength && element.Artifact.MimeType )
					{
						this.loadBlob(
							element, ( data: any ) =>
							{

								let srcStr: string = '';
								let thumb: any;

								if ( data.MimeType === 'application/pdf' )
								{
									thumb = ui.$$.div().append( ui.$$.span().addClass( 'far fa-file-pdf fa-5x' ).attr( 'style', 'margin-top:15%;' ) ).attr( 'style', 'text-align:center;' );								}
								else
								{
									srcStr = 'data:' + data.MimeType + ';' + ( data.Base64 ? 'base64,' : '' ) + data.Blob;
									thumb = ui.$$.img();
								}

								// Thumbnail
								const thumbnnaiill = ui.$$.div().addClass('row row-thumb')
									.append(
										ui.$$.div().addClass( 'col-xs-12 col-sm-6' )
											.append(
												thumb.css({width: '250px'})
													.attr('src', srcStr)
											)
									)
									.on(
										{
											mouseenter: () => thumb.css({opacity: '0.5', cursor: 'zoom-in'}),
											mouseleave: () => thumb.css({opacity: '1', cursor: 'default'}),
											click: () =>
												this.loadBlob(
													element, (data: any) => {
														const srcStr = 'data:' + data.MimeType + ';' + (data.Base64 ? 'base64,' : '');

														let modal: ui.dialog.Modal;

														let imgType: any;

														if (data.MimeType === 'application/pdf') {
															imgType = ui.$$.iframe();
														} else {
															imgType = ui.$$.img();
														}

														modal = new ui.dialog.Modal(
															{
																size: 'lg',
																noCloseBtn: true,
																css:
																	{
																		cursor: 'zoom-out'
																	},
																body: [imgType.attr('src', srcStr + data.Blob)]
															});
														modal.on('click', () => modal.Hide());
													}
												)
										}
									);
								AttachmentBox.append(thumbnnaiill);
							}
						);
					}

					row.append(
						ui.$$.div().addClass( 'col-xs-12 col-sm-6' )
							.append( ui.$$.span().text( app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.ATTACHMENT.LABEL.createdAt' ) ) )
							.append( ui.$$.span().text( new Date(element.CreatedAt).pattern('d.m.Y') ) )
							.append( ui.$$.br())
							.append( ui.$$.span().text( app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.ATTACHMENT.LABEL.lastEdited' ) ) )
							.append( ui.$$.span().text( element.LastEdited ? new Date(element.LastEdited).pattern('d.m.Y') : app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.ATTACHMENT.LABEL.not_yet_edited' ) ) )
					);
					AttachmentBox.append(row);

					ui.$$.button().
					on( 'click', () => this.buildEditAttachmentName(element) )
					.append( ui.$$.span().addClass( 'fas fa-pen' ) )
					.addClass( 'btn btn-primary' )
					.appendTo( buttonplane )
					.css(
						{
							width:	'39px',
							height:	'34px',
							margin:	'3px'
						}
					);

					if (element.Artifact && element.Artifact.DataLength && element.Artifact.MimeType)
					{
						// Anzeige
						ui.$$.button()
						.on('click',
							() => this.loadBlob(	element, (data: any ) => { this.buildPreviewModal(element, data); })
						)
						.append( ui.$$.span().addClass( 'fas fa-tv' ) )
						.addClass( 'btn btn-info' )
						.appendTo( buttonplane )
						.css(
							{
								width:	'39px',
								height:	'34px',
								margin:	'3px'
							}
						);

						// DOWNLOAD
						ui.$$.button()
						.on( 'click', () => this.loadBlob( element, ( data: Wollmilch.ArtifactDownload ) => this.downloadFile( data ) ) )
						.append( ui.$$.span().addClass( 'fas fa-download' ) )
						.addClass( 'btn btn-default' )
						.appendTo( buttonplane )
						.css(
							{
								width:	'39px',
								height:	'34px',
								margin:	'3px'
							}
						);
					}

					// REMOVE
					ui.$$.button().
					on( 'click', () => this.removeAttachment( element ) )
					.append( ui.$$.span().addClass( 'fas fa-trash' ) )
					.addClass( 'btn btn-danger' )
					.appendTo( buttonplane )
					.css(
					{
						width:	'39px',
						height:	'34px',
						margin:	'3px'
					}
					);

				}
				);

				return this;
			}

			/**
			 * Get Data from API and refresh View
			 */
			public refreshView() : void {

				new Wollmilch.AJAX({
					method: 'POST',
					url: 'document/refresh/' + btoa(this.m_Data.ObjectNumber),
					data: {
						time: this.docManager.getLastUpdate()
					},
					on: {
						success: (text) => {
							const _obj = JSON.parse(text);

							for (const file of _obj.data.files)
							{
								// Todo Determine add or replace
								const result = this.docContainer.filter((d) => {
									return d.file.default_id === file.default_id || d.file.id === file.id;
								});
								if (result.length === 0) {
									continue;
								}

								const changed = result[0].file.created_at !== file.created_at;
								const filenameChanged = result[0].file.filename !== file.filename;
								if ((changed || filenameChanged ) && file.group_id === result[0].file.group_id && file.default_id === result[0].file.default_id && file.default_id !== 0)
								{
									// Replace box by corresponding index
									const boxIndex = this.docContainer.findIndex((dc) =>
									{
										return dc.file.default_id === file.default_id || dc.file.id === file.id;
									});
									if (boxIndex === -1)
									{
										console.log("Replacement went wrong");
										return;
									}

									const Box = new DocumentBox(this.m_Data, file);
									this.docManager.setFile(file.id, file);
									this.docContainer[boxIndex].file = file;
									this.docContainer[boxIndex].el.replaceWith(Box.Build());
								}
							}
						}
					}
				}, AJAXCallbase_e.REALTOR).send();

			}

			private buildDocumentGroup(group: IDocumentGroup, root: JQuery)
			{
				root.empty();

				const customContainer = this.buildCustomBox(group);
				if (customContainer) {
					root.append(customContainer);
				}

				const files = this.docManager.getFilesInGroup(group.id);

				for (const file of files) {
					// const bDocument = new DocumentModel(file);
					// bGroup.add(bDocument);
					// bDocument.get('hund')

					// Additional data as a workaround for now
					// bDocument.set('ObjectNumber', this.m_Data.ObjectNumber);
					// bDocument.set('Object', this.m_Data);

					// const bView = new DocumentBoxView({model: bDocument});
					// documentContainer.append(bView.render().el);
					// console.log(bDocument.attributes, bDocument.hasChanged('filename'), bDocument.hasChanged());

					// TODO: Workaround for Expose Main IMG replacement: id 28
					if (file.default_id !== 28 ) {
						const Box = new SPA.Realtor.DocumentBox(this.m_Data, file);
						const BoxHtml = Box.Build();

						this.docContainer.push({file, el: BoxHtml});
						root.append(BoxHtml);
					}
				}
			}

			private buildCustomBox(group: any): JQuery | null
			{
				if (group.content === "predefined")
				{
					return null;
				}

				const customDocument: SPA.Realtor.IDocument = {
					id: 0,
					filename: '',
					title: 'Neue Dokumente hochladen',
					is_custom: true,
					group_id: group.id,
					default_title: '',
					default_id: 0,
					shop_item: null,
					created_at: null
				};
				const customBox = new SPA.Realtor.DocumentBox(this.m_Data, customDocument);

				return customBox.Build();
			}

			private downloadFile( data: Wollmilch.ArtifactDownload )
			{
				const srcStr = 'data:' + data.MimeType + ';' + ( data.Base64 ? 'base64,' : '' );
				const element = document.createElement('a');

				element.setAttribute( 'href', srcStr + data.Blob );
				/* Chapter2 - stores files with description as filename */
				element.setAttribute( 'download', data.Filename);

				element.click();
			}

			private buildPreviewModal(element: any, data: any)
			{
				const srcStr = 'data:' + data.MimeType + ';' + (data.Base64 ? 'base64,' : '');

				let modal: ui.dialog.Modal;

				let imgType: any;

				if (data.MimeType === 'application/pdf') {
					imgType = ui.$$.iframe();
				} else {
					imgType = ui.$$.img();
				}

				modal = new ui.dialog.Modal(
					{
						size: 'lg',
						head: [
							ui.$$.h(4, this.m_Data.ObjectNumber),
							ui.$$.h(3, element.Name)
						],
						body: [imgType.attr('src', srcStr + data.Blob)],
						foot: [ui.$$.span().text(app.getMessage('Aux.BASIC.OBJECT.REALTOR.ATTACHMENT.LABEL.createdAt') + new Date(element.CreatedAt).pattern('d.m.Y'))]
					}
				);
				modal.on('click', () => modal.Hide());
			}

			// private removeAttachment( att: Wollmilch.Realtor.Attachment )
			// {
			// 	// Request confirm for deletion
			// 	const proceed = confirm('Möchten Sie dieses Dokument wirklich unwiderruflich löschen?');
			// 	if (proceed === false) {
			// 		return;
			// 	}
			//
			// 	new Wollmilch.AJAX(
			// 		{
			// 			url: 'object/removeAttachment/' + encodeURIComponent(btoa(this.m_Data.ObjectNumber)) + '/' + att.Artifact.ID,
			// 			method: 'PATCH',
			// 			on:
			// 			{
			// 				success: ( text: string ) =>
			// 				{
			// 					const obj = Wollmilch.jsonize( text );
			//
			// 					if ( !obj )
			// 					{
			// 						return;
			// 					}
			//
			// 					if ( !obj.success )
			// 					{
			// 						app.addNotify(
			// 						{
			// 							title: [ app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.ATTACHMENT.title' ) ],
			// 							body: [ app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.ATTACHMENT.error_no_delete' ) ],
			// 							context: 'danger',
			// 							timeout: Number(app.getConfigValue("ToastTimeout")),
			// 						}
			// 						);
			// 						return;
			// 					}
			//
			// 					if ( obj.success )
			// 					{
			// 						app.addNotify(
			// 						{
			// 							title: [ app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.ATTACHMENT.title' ) ],
			// 							body: [ app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.ATTACHMENT.success_delete' ) ],
			// 							context: 'success',
			// 							timeout: Number(app.getConfigValue("ToastTimeout"))
			// 						}
			// 						);
			//
			// 						let i = 0;
			// 						(this.m_Data.Attachments as Wollmilch.Realtor.Attachment[]).forEach(
			// 							(element) =>
			// 							{
			// 								if ( element.Artifact.ID == att.Artifact.ID )
			// 								{
			// 									this.m_Data.Attachments.splice(i, 1);
			// 									return;
			// 								}
			// 								i++;
			// 							}
			// 						);
			//
			// 						if ( this.m_Parent ) { this.rebuild( this.m_Parent ); }
			// 					}
			// 				}
			// 			}
			// 		},
			// 		Wollmilch.AJAXCallbase_e.REALTOR
			// 	).send();
			// }

			// private loadBlob( att: Wollmilch.Realtor.Attachment, onsuccess: ( data: Wollmilch.ArtifactDownload ) => void )
			// {
			// 	new Wollmilch.AJAX(
			// 		{
			// 			url: 'artifact/download/' + att.Artifact.ID,
			// 			method: 'GET',
			// 			on:
			// 			{
			// 				success: ( text: string ) =>
			// 				{
			// 					const obj = Wollmilch.jsonize( text );
			//
			// 					if ( !obj || obj.success === false )
			// 					{
			// 						return;
			// 					}
			//
			// 					onsuccess( obj.data );
			// 				}
			// 			}
			// 		}
			// 	).send();
			// }

			private showModalBox(title: string, filename: string): void
			{
				let imgType: any;
				let imgSrc: string;
				let params: string;

				if (filename.indexOf('.pdf') !== -1) {
					imgType = ui.$$.iframe();
					imgSrc = 'uploads/demo/';
					params = '#view=FitH&scrollbar=1&toolbar=0&statusbar=0&messages=0&navpanes=0';
				} else {
					imgType = ui.$$.img();
					imgSrc = '';
					params = '';
				}

				new ui.dialog.Modal({
					size: 'quick7',
					noCloseBtn: false,
					head: [ui.$$.h(2, title)],
					body: [
						imgType.attr('src', imgSrc + filename + params)
					]
				});
			}
		}

	}
}
